import React, { useState } from 'react';
import OrgSidebar from './components/OrgSidebar';
import OrgTopbar from './components/OrgTopbar';
import Footer from '../admin/components/Footer';
import OrgFooter from './components/OrgFooter';
import { Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import CourseList from './pages/CourseList';
import ManageUsers from './pages/ManageUsers';
import ManageAdmins from './pages/ManageAdmins';
import ManageLicenses from './pages/ManageLicenses';
import OrgSupportTicketsPage from './pages/SupportTickets/OrgSupportTicketsPage';
import OrgForumList from './pages/Forums/OrgForumList';
import OrgForumDetail from './pages/Forums/OrgForumDetail';
import OrgVltList from './pages/Vlt/OrgVltList';
import OrgEventCalendarPage from './pages/Calendar/OrgEventCalendarPage';
import OrgSurveyList from './pages/Surveys/OrgSurveyList';
import OrgSurveyQuestions from './pages/Surveys/OrgSurveyQuestions';
import OrgSurveyResponses from './pages/Surveys/OrgSurveyResponses';
import OrgAssessmentList from './pages/Assessments/OrgAssessmentList';
import OrgAssessmentAssignments from './pages/Assessments/OrgAssessmentAssignments';
import OrgAssessmentAnalytics from './pages/Assessments/OrgAssessmentAnalytics';
import AssessmentQuestions from '../admin/pages/Assessments/AssessmentQuestions';
import OrganizationCertificateTemplatesPage from './pages/CertificateManagement/CertificateTemplatesPage';
import OrgTermsPage from './pages/OrgTermsPage';
import OrgPrivacyPage from './pages/OrgPrivacyPage';
import OrgFaqPage from './pages/OrgFaqPage';
import ProfilePage from '../common/pages/ProfilePage';
import ChangePasswordPage from '../common/pages/ChangePasswordPage';
import CourseCompletions from './pages/Reports/CourseCompletions';
import UsersReport from './pages/Reports/UsersReport';
import EnrollmentsReport from './pages/Reports/EnrollmentsReport';
import OrganizationsReport from './pages/Reports/OrganizationsReport';
import SurveyReport from './pages/Reports/SurveyReport';
import VoucherReport from './pages/Reports/VoucherReport';
import TicketReport from './pages/Reports/TicketReport';
import OrgLeaderboardPage from './pages/Gamification/LeaderboardPage';
import { Offcanvas } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';

const Layout = () => {
  const [sidebarShow, setSidebarShow] = useState(false);
  const isMdUp = useMediaQuery({ minWidth: 768 });

  const handleTabChange = () => {
    setSidebarShow(false);
  };

  return (
    <>
      <div className="container-fluid vh-100 d-flex flex-row p-0 flex flex-col md:flex-row overflow-hidden">
        {/* Sidebar for md+ screens */}
        {isMdUp && (
          <div className="fixed top-0 left-0 h-full overflow-y-auto transition-transform transform -translate-x-full md:translate-x-0 md:static md:flex-shrink-0 w-full md:w-[260px] brand-app-sidebar z-50 md:z-auto">
            <OrgSidebar onTabChange={handleTabChange} />
          </div>
        )}
        {/* Offcanvas Sidebar for mobile */}
        {!isMdUp && (
          <Offcanvas show={sidebarShow} onHide={() => setSidebarShow(false)} style={{ backgroundColor: '#ffffff', width: '260px' }}>
            <Offcanvas.Header closeButton style={{ borderBottomColor: '#dee2e6', backgroundColor: '#ffffff' }}>
              <Offcanvas.Title style={{ color: '#495057' }}>Organization Admin</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="p-0">
              <OrgSidebar onTabChange={handleTabChange} />
            </Offcanvas.Body>
          </Offcanvas>
        )}
        {/* Main Content */}
        <div className="flex-grow-1 d-flex flex-column min-vh-100 flex flex-col flex-1 overflow-y-auto bg-white/90">
          <div className="border-bottom sticky top-0 z-40 items-center justify-between shadow-md">
            <OrgTopbar onMenuClick={() => setSidebarShow(true)} />
          </div>
          <div className="flex-grow-1 overflow-auto p-2 flex-1 overflow-y-auto sm:p-5 md:p-2 lg:p-2">
            <Routes>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/courses" element={<CourseList />} />
              <Route path="/certificate-templates" element={<OrganizationCertificateTemplatesPage />} />
              <Route path="/surveys" element={<OrgSurveyList />} />
              <Route path="/surveys/:id/questions" element={<OrgSurveyQuestions />} />
              <Route path="/surveys/:id/responses" element={<OrgSurveyResponses />} />
              <Route path="/assessments" element={<OrgAssessmentList />} />
              <Route path="/assessments/:id/questions" element={<AssessmentQuestions />} />
              <Route path="/assessments/:id/assignments" element={<OrgAssessmentAssignments />} />
              <Route path="/assessments/:id/analytics" element={<OrgAssessmentAnalytics />} />
              <Route path="/manage-users" element={<ManageUsers />} />
              <Route path="/manage-admins" element={<ManageAdmins />} />
              <Route path="/manage-licenses" element={<ManageLicenses />} />
              <Route path="/support-tickets" element={<OrgSupportTicketsPage />} />
              <Route path="/forums" element={<OrgForumList />} />
              <Route path="/forums/:id" element={<OrgForumDetail />} />
              <Route path="/vlt" element={<OrgVltList />} />
              <Route path="/calendar" element={<OrgEventCalendarPage />} />
              <Route path="/reports/users" element={<UsersReport />} />
              <Route path="/reports/course-enrollments" element={<EnrollmentsReport />} />
              <Route path="/reports/organizations" element={<OrganizationsReport />} />
              <Route path="/reports/surveys" element={<SurveyReport />} />
              <Route path="/reports/course-completions" element={<CourseCompletions />} />
              <Route path="/reports/vouchers" element={<VoucherReport />} />
              <Route path="/reports/tickets" element={<TicketReport />} />
              <Route path="/leaderboard" element={<OrgLeaderboardPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/change-password" element={<ChangePasswordPage />} />
              <Route path="/terms" element={<OrgTermsPage />} />
              <Route path="/privacy" element={<OrgPrivacyPage />} />
              <Route path="/faqs" element={<OrgFaqPage />} />
              <Route path="/" element={<Dashboard />} />
            </Routes>
          </div>
          <OrgFooter />
        </div>
      </div>
    </>
  );
};

export default Layout;
